import { services } from "api/serviceConfig";
import { makeAutoObservable } from "mobx";
import { PageRequest } from "api/sharedModels/PageRequest";
import { Customer } from "models/users/Customer";
import { MarvelModule } from "models/users/MarvelModule";
import CustomerIdRequest from "api/sharedModels/CustomerIdRequest";

export class CustomerStore {
    constructor() {
        makeAutoObservable(this);
    }

    customers: Customer[] = [];
    currentPage = 1;
    totalPages = 1;
    areCustomersLoading = false;

    modules: MarvelModule[] = [];
    areModulesLoading = false;

    get isLastPage() {
        return this.currentPage === this.totalPages;
    }

    setPage = (page: number) => {
        this.currentPage = page;
    };

    movePage = (direction: "back" | "forward") => {
        direction === "back" ? this.currentPage-- : this.currentPage++;
    };

    loadCustomers = async (request: PageRequest) => {
        this.areCustomersLoading = true;

        try {
            const response = await services.UserManagement.getCustomersList(request);

            this.customers = response.data.items;
            this.totalPages = response.data.totalPages;
        } catch (error) {
            console.log(error);
        } finally {
            this.areCustomersLoading = false;
        }
    };

    loadModules = async (request: CustomerIdRequest) => {
        this.areModulesLoading = true;

        try {
            const response = await services.UserManagement.getModulesList(request);

            this.modules = response.data;
        } catch (error) {
            console.log(error);
        } finally {
            this.areModulesLoading = false;
        }
    };
}
